import { render, staticRenderFns } from "./ColunaDireita.vue?vue&type=template&id=c44b7a80&scoped=true&"
import script from "./ColunaDireita.vue?vue&type=script&lang=js&"
export * from "./ColunaDireita.vue?vue&type=script&lang=js&"
import style0 from "./ColunaDireita.vue?vue&type=style&index=0&id=c44b7a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44b7a80",
  null
  
)

export default component.exports